export function getDiscountGrossChartData({
  objects,
  selectedStoreCode,
  selectedMonthName,
  selectedYear,
  monthsToShow = 12,
}) {
  // 1) filter only completed ("C") transactions
  const filtered = (objects || [])
    .filter((o) => o.status === "C")
    .filter((sale) => {
      const d = new Date(sale.tran_date);
      const year = d.getFullYear();
      const month = d.toLocaleString("default", { month: "long" });
      const store = sale.store_code.replace("ANGELSPIZZA_", "");

      const okYear = selectedYear ? year === parseInt(selectedYear, 10) : true;
      const okMonth = selectedMonthName ? month === selectedMonthName : true;
      const okStore = selectedStoreCode ? store === selectedStoreCode : true;

      return okYear && okMonth && okStore;
    });

  // 2) accumulate gross & discount per month over the last `monthsToShow`
  const now = new Date();
  const labels = [];
  const salesData = [];
  const discountData = [];

  for (let i = monthsToShow - 1; i >= 0; i--) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const month = d.getMonth();
    const year = d.getFullYear();

    // pick only transactions in this month/year
    const monthTx = filtered.filter((tx) => {
      const t = new Date(tx.tran_date);
      return t.getMonth() === month && t.getFullYear() === year;
    });

    if (monthTx.length) {
      let grossSum = 0;
      let discountSum = 0;

      monthTx.forEach((tx) => {
        const total = Number(tx.total || 0);
        const discount = Number(tx.discount_amount || 0);
        // as per your logic, gross = total
        grossSum += total;
        discountSum += discount;
      });

      labels.push(
        d.toLocaleString("default", { month: "long", year: "numeric" })
      );
      salesData.push(grossSum);
      discountData.push(discountSum);
    }
  }

  return { labels, salesData, discountData };
}

/**
 * Build Highcharts options for dual-axis Gross Sales (column) +
 * Discount Amount (spline) chart.
 */
export function getDiscountGrossChartOptions({ labels, salesData, discountData }) {
  return {
    chart: { zoomType: "xy" },
    title: { text: null },
    xAxis: {
      categories: labels,
      crosshair: true,
    },
    yAxis: [
      {
        title: { text: "Gross Sales (PHP)" },
        labels: {
          formatter() {
            return "\u20B1" + this.value.toLocaleString();
          },
        },
      },
      {
        title: { text: "Discount Amount (PHP)" },
        labels: {
          formatter() {
            return "\u20B1" + this.value.toLocaleString();
          },
        },
        opposite: true,
      },
    ],
    tooltip: { shared: true },
    series: [
      {
        name: "Gross Sales",
        type: "column",
        data: salesData,
        color: "#006096",
        yAxis: 0,
        tooltip: {
          valuePrefix: "\u20B1",
          valueDecimals: 2,
        },
      },
      {
        name: "Discount Amount",
        type: "spline",
        data: discountData,
        color: "#ffd043",
        lineWidth: 3,
        marker: { enabled: true, radius: 4, symbol: "circle" },
        yAxis: 1,
        tooltip: {
          valuePrefix: "\u20B1",
          valueDecimals: 2,
        },
      },
    ],
    credits: { enabled: false },
  };
}
